import React from 'react';
import { useUsageRight } from '../UsageRightsProvider';
import GeneralTable from '../../../common/GeneralTable/GeneralTable';
import GeneralTableHead from '../../../common/GeneralTable/GeneralTableHead';
import GeneralTableData from '../../../common/GeneralTable/GeneralTableData';
import UsageRightStatusTag from '../UsageRightStatusTag';
import styles from '../../../../styles/usageRights.module.css';
import TypeTag from '../TypeTag';
import MediaThumbnail from '../MediaThumbnail';
import { dayjs } from '../../../../utils/dayjs-utils';
import CaptionContainer from './CaptionContainer';
import MiniStat from './MiniState';
import ImpressionsIcon from '../../../../assets/icons/ImpressionsIcon';
import CommentIcon from '../../../../assets/icons/CommentIcon';
import HeartLikeIcon from '../../../../assets/icons/HeartLikeIcon';
import ActionsSection from './ActionSection';

const headers: { text: string; align?: CanvasTextAlign }[] = [
  { text: 'Media', align: 'center' },
  { text: 'Status', align: 'center' },
  { text: 'Type', align: 'center' },
  { text: 'Brand', align: 'center' },
  { text: 'Date', align: 'center' },
  { text: 'Caption' },
  { text: 'Impressions', align: 'center' },
  { text: 'Comments', align: 'center' },
  { text: 'Likes', align: 'center' },
  { text: 'Action', align: 'center' },
];

function UsageRightTable() {
  const { currentData, setSelectedRequest } = useUsageRight();
  return (
    <GeneralTable>
      <thead>
        <tr style={{ boxShadow: '0px 9px 10px 0px rgba(0, 0, 0, 0.05)' }}>
          {headers.map((head) => (
            <GeneralTableHead style={{ textAlign: head?.align || 'left' }} key={head.text}>
              {head.text}
            </GeneralTableHead>
          ))}
        </tr>
      </thead>
      <tbody>
        {currentData?.map((content) => (
          <tr key={content?._id}>
            <GeneralTableData>
              <MediaThumbnail thumbnail={content?.thumbnail} type={content.type} />
            </GeneralTableData>
            <GeneralTableData>
              <div className={styles.tableDataWrapper}>
                <UsageRightStatusTag status={content?.status} />
              </div>
            </GeneralTableData>
            <GeneralTableData>
              <div className={styles.tableDataWrapper}>
                <TypeTag type={content?.type} />
              </div>
            </GeneralTableData>
            <GeneralTableData>
              <div className={styles.brandContainer}>{content.brandName}</div>
            </GeneralTableData>
            <GeneralTableData>
              <div className={styles.tableDateContainer}>
                {dayjs(content?.creativeCreatedDate).format('MMM DD, YYYY')}
              </div>
            </GeneralTableData>
            <GeneralTableData>
              <CaptionContainer caption={content?.caption} type={content.type} />
            </GeneralTableData>
            <GeneralTableData>
              <MiniStat icon={<ImpressionsIcon width={24} height={24} />} stat={content?.impressions} />
            </GeneralTableData>
            <GeneralTableData>
              <MiniStat icon={<CommentIcon width={20} height={20} color="#BDBDBD" />} stat={content?.comments} />
            </GeneralTableData>
            <GeneralTableData>
              <MiniStat icon={<HeartLikeIcon width={24} height={24} color="#BDBDBD" />} stat={content?.likes} />
            </GeneralTableData>
            <GeneralTableData>
              <ActionsSection onClick={() => setSelectedRequest(content)} />
            </GeneralTableData>
          </tr>
        ))}
      </tbody>
    </GeneralTable>
  );
}

export default UsageRightTable;
